import { createStore } from 'vuex';
import usersModule from './modules/users-module';
import billCyclesModule from './modules/bill-cycles-module';
import customersModule from './modules/customers-module';
import picklistsModule from './modules/picklists-module';

// eslint-disable-next-line no-unused-vars
function testFilter(prod) {
  return prod.name.includes('ir');
}

const store = createStore({
  modules: {
    users: usersModule,
    billCycles: billCyclesModule,
    customers: customersModule,
    pickLists: picklistsModule,
  },
  state() {
    return {
      products: [
        { name: 'first', desc: 'test1' },
        { name: 'second', desc: 'test2' },
        { name: 'third', desc: 'test3' },
        { name: 'fourth', desc: 'test4' },
      ],
      produtFilter: null,
    };
  },
  mutations: {
    setProductFilter(state, payload) {
      state.productFilter = payload;
    },
  },
  getters: {
    filteredProducts(state) {
      return state.products.filter(testFilter);
    },
  },
  actions: {},
});
export default store;
